import React, { useContext } from 'react';

import { media } from 'context';
import { app } from 'context';
import { Grid, Icon, Layout, Text } from 'ds';

interface Props {}

const OnePortalToRuleThemAll: React.FC<Props> = () => {
  const { xs } = useContext(media);
  const { windowWidth } = useContext(app);

  const gridItems = [
    {
      icon: 'sparkle',
      title: 'AI office assistant',
      rotate: false
    },
    {
      icon: 'coffee',
      title: 'Beverages',
      rotate: false
    },
    {
      icon: 'snack',
      title: 'Snacks',
      rotate: false
    },
    {
      icon: 'featherDuster',
      title: 'Cleaning',
      rotate: true
    },
    {
      icon: 'wifi',
      title: 'Internet',
      rotate: false
    },
    {
      icon: 'chair',
      title: 'Furniture',
      rotate: false
    }
  ];
  return (
    <Layout height={xs ? 514 : 360} width={xs ? '100vw' : undefined}>
      {!xs && <Layout position="absolute" left={0} width={windowWidth} height={360} color="blue-100" />}
      <Layout
        position="relative"
        color="blue-100"
        direction="column"
        height="100%"
        gap={52}
        justify="center"
        align="center"
        flexGrow={1}
      >
        <Layout>
          <Text size="headline-lg" color="blue-600" align="center">
            {xs ? (
              <>
                One portal
                <br />
                to rule them all
              </>
            ) : (
              'One portal to rule them all'
            )}
          </Text>
        </Layout>
        <Layout width="100%" maxWidth={xs ? 342 : undefined}>
          <Grid itemsPerRow={xs ? 3 : 6} gapY={60}>
            {gridItems.map((item, index) => (
              <Layout key={index} direction="column" gap={12} justify="flex-start" align="center">
                <Layout style={{ transform: item.rotate ? 'rotate(180deg)' : 'none' }}>
                  <Icon name={item.icon as any} size="xl" color="blue-600" />
                </Layout>
                <Text size="headline-xs" color="blue-600" align="center">
                  {item.title}
                </Text>
              </Layout>
            ))}
          </Grid>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default OnePortalToRuleThemAll;
